import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';
import { toast } from 'sonner';
import { apiError } from '../lib/apiError';

export const useTeacherSessions = (scope) => {
  const [sessions, setSessions] = useState(null);
  useEffect(() => {
    axios.get(`${API}/teacher-portal/sessions`, { params: { scope } })
      .then((r) => setSessions(r.data || []))
      .catch((e) => { toast.error(apiError(e, 'Failed to load sessions')); setSessions([]); });
  }, [scope]);
  return sessions;
};
